export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6">
        <div className="py-10 md:py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-line text-foreground-50 text-base"></i>
                </div>
                <span className="text-lg font-bold text-foreground-50 font-heading whitespace-nowrap">成全影视</span>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">
                高清免费在线追剧平台，提供海量电视剧全集播放，不缓冲不卡顿，免VIP流畅追剧。每日更新最新热门电视剧，随时随地免费看。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4 whitespace-nowrap">快速导航</h4>
              <div className="flex flex-col gap-2">
                <a href="#media" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门剧集</a>
                <a href="#cards" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精选推荐</a>
                <a href="#ranking" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热播排行</a>
                <a href="#updates" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">最新动态</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4 whitespace-nowrap">题材分类</h4>
              <div className="flex flex-col gap-2">
                <a href="#index" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">古装仙侠</a>
                <a href="#index" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">悬疑推理</a>
                <a href="#index" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">都市情感</a>
                <a href="#index" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">科幻奇幻</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4 whitespace-nowrap">合作伙伴</h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                诚邀优质影视内容方与品牌方加入合作生态。
              </p>
              <a href="#contact" className="inline-block mt-3 text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">
                合作咨询 →
              </a>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/40">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-xs text-foreground-600">
                &copy; {new Date().getFullYear()} 成全影视 - 电视剧全集免费在线观看。本站所有内容仅供娱乐交流，版权归原作者所有。
              </p>
              <div className="flex items-center gap-4">
                <a href="#faq" className="text-xs text-foreground-600 hover:text-foreground-300 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
                <a href="#about" className="text-xs text-foreground-600 hover:text-foreground-300 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
                <a href="#contact" className="text-xs text-foreground-600 hover:text-foreground-300 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}